window.onload = function() {
 // if ($(window).width() < 1200) {
      $('a').click(function(){
        $('html, body').animate({
            scrollTop: $( $(this).attr('href') ).offset().top
        }, 500);
        return false;
    });

    var topMenu = $(".essences-prod-story"),
        topMenuHeight = topMenu.outerHeight()+190,
        menuItems = topMenu.find("a"),
        scrollItems = menuItems.map(function(){
          var item = $($(this).attr("href"));
          if (item.length) { return item; }
        });

      $(window).scroll(function(){
         var fromTop = $(this).scrollTop()+topMenuHeight;
      
         var cur = scrollItems.map(function(){
           if ($(this).offset().top < fromTop)
             return this;
         });
         cur = cur[cur.length-1];
         var id = cur && cur.length ? cur[0].id : "";
         menuItems
           .parent().removeClass("active")
           .end().filter("[href='#"+id+"']").parent().addClass("active");
      });
 // } else {
 //      var swiperTab = new Swiper(".sliderTab", {
 //      slidesPerView: "auto",
 //      preventClicks: true,
 //      preventClicksPropagation: false,
 //      observer: true,
 //      observeParents: true
 //    });

 //    var $snbSwiperItem = $(".sliderTab .swiper-wrapper .swiper-slide a");
 //    $snbSwiperItem.click(function () {
 //      var target = $(this).parent();
 //      $snbSwiperItem.parent().removeClass("on");
 //      target.addClass("on");
 //      muCenter(target);
 //    });
    
 //    function muCenter(target) {
 //      var snbwrap = $(".sliderTab .swiper-wrapper");
 //      var targetPos = target.position();
 //      var box = $(".sliderTab");
 //      var boxHarf = box.width() / 2;
 //      var pos;
 //      var listWidth = 0;
    
 //      snbwrap.find(".swiper-slide").each(function () {
 //        listWidth += $(this).outerWidth();
 //      });
    
 //      var selectTargetPos = targetPos.left + target.outerWidth() / 2;
 //      if (selectTargetPos <= boxHarf) {
 //        // left
 //        pos = 0;
 //      } else if (listWidth - selectTargetPos <= boxHarf) {
 //        //right
 //        pos = listWidth - box.width();
 //      } else {
 //        pos = selectTargetPos - boxHarf;
 //      }
    
 //      setTimeout(function () {
 //        snbwrap.css({
 //          transform: "translate3d(" + pos * -1 + "px, 0, 0)",
 //          "transition-duration": "250ms"
 //        });
 //      }, 100);
 //    }
    
 //    var swiperContent = new Swiper(".sliderContent", {
 //      slidesPerView: 1,
 //      allowTouchMove: true,
 //      thumbs: {
 //        swiper: swiperTab
 //      }
 //    });
 //  }
}